const path = {
  login: '/login',
  signup: '/signup',
  profile: '/profile',
  resetPassword: '/reset-password',
  confirmEmail: '/confirm-email',
  home: '/home',
  createAuction: '/create-auction',
  searchAuction: '/search',
  rating: '/',
  dashboard: '/dashboard',
  createOffer: '/search',
}

const message = {}

export { path, message }
